export default "__VITE_ASSET__DUC8x7QS__"